import React from 'react';
import { type DialogProps, Modal, ModalOverlay, Dialog as RACDialog, composeRenderProps } from 'react-aria-components';
import { cn } from './utils';
import { modalStyles } from './modal/Modal';

export function dialogOverlayStyles(renderProps: { isEntering?: boolean; isExiting?: boolean }) {
	return cn(
		'fixed inset-0 z-20 flex items-center justify-center bg-black/[50%] backdrop-blur-lg',
		renderProps.isEntering && 'animate-in fade-in duration-200 ease-out',
		renderProps.isExiting && 'animate-out fade-out duration-200 ease-in'
	);
}

export function Dialog(props: DialogProps) {
	return (
		<ModalOverlay
			className={renderProps => dialogOverlayStyles(renderProps)}
			isOpen
		>
			<Modal className={renderProps => modalStyles(renderProps)}>
				<RACDialog
					{...props}
					className={cn('relative max-h-[inherit] overflow-auto p-6 outline outline-0 [[data-placement]>&]:p-4', props.className)}
				/>
			</Modal>
		</ModalOverlay>
	);
}
